<template>

    <rkm-tabs
        v-model="tabIndex"
        :tab-refs="tabRefs"
    >

        <rkm-tab
            active
            key="area"
            title="Área"
        >
            <TabArea
                ref="TabArea"
                :data="data"
            />
        </rkm-tab>

        <rkm-tab
            key="equipe"
            title="Equipe"
        >
            <TabEquipe
                ref="TabEquipe"
                :data="data"
            />
        </rkm-tab>

        <rkm-tab
            key="faturamento"
            title="Faturamento"
        >
            <TabFaturamento
                ref="TabFaturamento"
                :data="data"
            />
        </rkm-tab>

        <rkm-tab
            key="outros"
            title="Outros"
        >
            <TabOutros
                ref="TabOutros"
                :data="data"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>

import TabArea from './components/area/Form'
import TabEquipe from './components/equipe/Form'
import TabFaturamento from './components/faturamento/Form'
import TabOutros from './components/outros/Form'

export default {
    components: {
        TabArea,
        TabEquipe,
        TabFaturamento,
        TabOutros,
    },
    props: {
        data: { type: Object, required: true },
    },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    methods: {
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
    },
    mounted() {

        this.tabRefs = [
            this.$refs.TabArea,
            this.$refs.TabEquipe,
            this.$refs.TabFaturamento,
            this.$refs.TabOutros,
        ]
    }
}
</script>